import {COMMENTS_MODAL_SEARCH_PARAM_VALUE, MODAL_SEARCH_PARAM_KEY} from '../../website-ui/constants/url';

import {addListenerByShareContainer, onCopyLink} from './share';

export const addListenerByMobileOpenComments = ($target, $container) => {
  $container?.addEventListener('click', () => {
    const url = new URL($target.dataset.url);

    url.searchParams.set(MODAL_SEARCH_PARAM_KEY, COMMENTS_MODAL_SEARCH_PARAM_VALUE);
    window.history.pushState({id: $target.dataset.id, target: 'mobile'}, null, url);
    const navEvent = new PopStateEvent('popstate');

    window.dispatchEvent(navEvent);
  });
};

const initHandlersForBottomNav = ($currentContentType, $comments, $share) => {
  if ($currentContentType && $comments && $share) {
    addListenerByMobileOpenComments($currentContentType, $comments);
    addListenerByShareContainer($currentContentType, $share);
  }
};

export const addEventHandlers = ($currentContentType, isMobile) => {
  if ($currentContentType) {
    const $commentsWrapper = $currentContentType.querySelector('.js-comments');

    if (isMobile) {
      initHandlersForBottomNav(
        $currentContentType,
        $commentsWrapper,
        $currentContentType.querySelector('.js-share')
      );
    } else {
      onCopyLink($currentContentType);
    }

    const $previewWidgetQuizButton = $currentContentType.querySelector('.js-preview-widget-quiz-button');

    if ($previewWidgetQuizButton) {
      $previewWidgetQuizButton.addEventListener('click', () => {
        import(/* webpackChunkName: "widget-quiz" */ '../../modules/quiz/quiz.js').then(module => {
          module.default({
            id: Math.random(),
            variant: $previewWidgetQuizButton.dataset?.variant || 'primary'
          });
        });
      });
    }
  }
};
